import request from '../../shared/request'

export const fetchAll = () => {
  return request('v1/crud/access?get=1');
};
